import React, { Component } from "react";
import {
  DataGrid,
  FilterRow,
  Editing,
  Column,
  Paging,
  Pager,
  FormItem,
} from "devextreme-react/data-grid";
import uiInfo from "../../ui-info";
import PaginaToolbar from "../../components/PaginaToolbar";
import { criarCnaePrefeituraDs } from "../../DataSources";

const localStorageKey = "cadastroCnaesPrefeituraGridState";

export default class CnaePrefeituraBox extends Component {
  constructor() {
    super();
    this._gridInstance = React.createRef();
    this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
  }

  onAtualizandoRow(e) {
    e.cancel = true;
    this.props.history.push("cnaeprefeitura/editar/" + e.data.id);
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <PaginaToolbar
            titulo="CNAE Prefeitura"
            novoCb={this.novoRegistro.bind(this)}
          >
            <DataGrid
              ref={(grid) => (this._gridInstance = grid)}
              dataSource={criarCnaePrefeituraDs()}
              showBorders={true}
              rowAlternationEnabled={true}
              remoteOperations={true}
              columnAutoWidth={true}
              focusedRowEnabled={true}
              wordWrapEnabled={true}
              filterSyncEnabled={true}
              onEditingStart={this.onAtualizandoRow}
            >
              <FilterRow visible={true} />
              <Editing
                allowDeleting={true}
                allowUpdating={true}
                useIcons={true}
              />
              <Column
                dataField={"id"}
                caption={"#"}
                allowEditing={false}
                alignment={"center"}
                width={80}
              />
              <Column
                dataField={"prefeituraId"}
                caption={"Prefeitura"}
                visible={false}
              >
                <FormItem visible={false}></FormItem>
              </Column>
              <Column dataField={"codigo"} caption={"Código"} width={110} />
              <Column
                dataField={"codigosLcp116"}
                caption={"Códigos LCP 116"}
                width={110}
              />
              <Column dataField={"descricao"} caption={"Descrição"} />
              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
              <Pager
                showPageSizeSelector={true}
                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
              />
            </DataGrid>
          </PaginaToolbar>
        </div>
      </React.Fragment>
    );
  }

  novoRegistro() {
    let gridState = this._gridInstance.instance.state();
    localStorage.setItem(localStorageKey, JSON.stringify(gridState));
    this.props.history.push("cnaeprefeitura/novo");
  }
}
